import { Component, OnInit } from '@angular/core';
import {RegisterFormService} from '../shared/services/registerFormService/register-form.service';
import {FormBuilder, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {FormsService} from '../shared/services/databaseServices/forms/forms.service';
import {Form} from '../shared/classes/Form';
import {PayService} from '../shared/services/payService/pay.service';
import {Token} from '../pay-method/Token';
import {Payer} from '../shared/classes/Payer';
import {GoPayService} from '../shared/services/goPayService/go-pay.service';
import {GoPay} from '../shared/classes/GoPay';
import {faCreditCard, faMoneyBillAlt, faUniversity} from '@fortawesome/free-solid-svg-icons';
import {EmailService} from '../shared/services/emailService/email.service';
import {RacerService} from '../shared/services/databaseServices/racer/racer.service';
import {PayInfo} from '../shared/classes/PayInfo';
import {EmailTableService} from '../shared/services/databaseServices/emailTable/email-table.service';
import {EmailTable} from '../shared/classes/EmailTable';
import {VarSymService} from '../shared/services/varSym/var-sym.service';
import {Location} from '@angular/common';
import {MailComponent} from '../mail/mail.component';
import {VoucherService} from '../shared/services/voucher/voucher.service';
import {Voucher} from '../shared/classes/Voucher';

@Component({
  selector: 'app-recapitulation-form',
  templateUrl: './recapitulation-form.component.html',
  styleUrls: ['./recapitulation-form.component.css']
})
export class RecapitulationFormComponent implements OnInit {

  key_name = '{field:jmeno}';
  key_surname = '{field:prijmeni}';
  key_year = '{field:roknarozeni}';
  key_club = '{field:klub}';
  key_startFee = '{field:startovne}';
  key_varSym = '{field:varSym}';
  key_account = '{field:ucet}';
  key_note = '{field:poznamka}';

  form: Form = undefined;
  formArray = undefined;
  currentStartFee = undefined;
  discount = 0;
  paying = false;

  faMoney = faMoneyBillAlt;
  faCard = faCreditCard;
  faFio = faUniversity;
  noErr = false;
  errCode = 0;
  payer: Payer = new Payer();

  goPay: GoPay;

  sortBy: string[] = [
    'name',
    'surname',
    'sex',
    'year',
    'email',
    'mobile',
    'category',
    'track',
    'club',
    'familyTandem',
    'team',
    'city',
    'country',
    'tshirt',
    'tshirtSize',
    'acomodation',
    'eat',
    'contactPerson',
    'voucher',
    'note',
    'lunch',
    'gdpr',
    'newsletter'
  ];

  constructor(private registerFormService: RegisterFormService,
              private router: Router,
              private location: Location,
              private emailTableService: EmailTableService,
              private racerService: RacerService,
              private varSymService: VarSymService,
              private voucherService: VoucherService,
              private formBuilder: FormBuilder,
              private emailService: EmailService,
              private activatedRoure: ActivatedRoute,
              private formService: FormsService,
              private goPayService: GoPayService,
              private payService: PayService) { }

  ngOnInit() {
    this.paying = false;
    this.errCode = 0;
    this.form = this.registerFormService.form;
    console.dir(this.registerFormService.form);
    this.setCurrentStartFee();
    const data = this.registerFormService.regForm;
    if(data.voucher === ''){
      this.discount = 0;
    } else {
      this.voucherService.readOne(this.form.race.id).then(dVoucher => {
        const voucherList: Voucher[] = dVoucher.data().vouchers;
        const voucher: Voucher = voucherList.find(i => i.keyword === data.voucher);
        if(voucher === undefined){
          this.errCode = 1;
          this.discount = 0;
        } else {
          if(voucher.pieces > 0 && voucher.type === 'ABS'){
            this.discount = voucher.value;
            this.noErr = true;
          }
          else if (voucher.pieces > 0 && voucher.type === '%') {
            this.discount = this.currentStartFee.value / 100 * voucher.value;
            this.noErr = true;
          } else {
            this.errCode = 2;
            this.discount = 0;
          }
        }
      })
    }

    this.setPayer(data);
    this.formArray = Object.entries(data).map(([key, value]) => ({key, value}));

    this.formArray.forEach( i => {
      if (this.showItem(i.key)) {
      }
    });

    const arr = [];
    this.sortBy.forEach(item => {
      arr.push(this.formArray.filter(i => i.key.toLowerCase() === item.toLowerCase())[0]);
    });
    this.formArray = arr;
  }

  setPayer(data) {
    this.payer.name = data.name;
    this.payer.surname = data.surname;
    this.payer.email = data.email;
    this.payer.mobile = data.mobile;
    this.payer.countryCode = data.country;
    this.payer.city = data.city;
    this.payer.postalCode = '';
    this.payer.street = '';
    this.payer.symbol = 'sym';
  }

  getCategory() {
    return this.form.race.categories.find(i => i.name === this.registerFormService.regForm.category).short;
  }

  getCategoryName(){
    return this.form.race.categories.find(i => i.name === this.registerFormService.regForm.category).name;
  }

  setCurrentStartFee() {
    const now: number = new Date().getTime() / 1000;
    this.form.race.startFee.sort((a, b) => {
      return a.finishDate - b.finishDate;
    });
    for (let i = 0; i < this.form.race.startFee.length; i++) {
      if(this.form.race.startFee[i].finishDate.seconds){
        if (Number(now) <= Number(this.form.race.startFee[i].finishDate.seconds)) {
          this.currentStartFee = this.form.race.startFee[i];
          break;
        }
      } else {
        if (now <= this.form.race.startFee[i].finishDate) {
          this.currentStartFee = this.form.race.startFee[i];
          break;
        }
      }
    }
    if (!this.currentStartFee) {
      this.currentStartFee = this.form.race.startFee[this.form.race.startFee.length - 1 ];
    }
    this.currentStartFee.value = this.currentStartFee.data.filter( item => item.category ===  this.getCategory() || item.category ===  this.getCategoryName())[0].fee[0].money;
  }

  showItem(itemName) {
    if(itemName === 'rules' || itemName === 'gdpr' || itemName === 'media') {
      return false
    }
    return this.form.formItems.filter(item => item.key === itemName)[0].visible;
  }

  isBool(item): boolean {
    return typeof(item) === 'boolean';
  }

  getTranslateString(item) {
    return `settingPage.formBuilder.formBuilder.item.${item}`;
  }

  getTotal(constanta = 1): number {
    return (this.currentStartFee.value - this.discount) * constanta;
  }

  sendEmail(subject, message) {
    const fromEmail = this.form.race.emailOr;
    const toEmail = this.formArray.filter(i => i.key === 'email')[0].value;
    this.emailService.sendEmail(fromEmail , toEmail, subject, message).then(data => {

    });
  }

  private generatePayInfo(payInfo: PayInfo): string {
    let ret = '';
    ret = `Pro platbu platbu převodem z účtu použijte tyto údaje: <br>`;
    ret = `${ret} Číslo účtu příjemnce: ${payInfo.account}<br>`;
    ret = `${ret} Částka: ${payInfo.startFee} Kč<br>`;
    ret = `${ret} Variabilní symbol: ${payInfo.vs}<br>`;
    ret = `${ret} Poznámka pro přijemnce musí obsahovat: ${payInfo.note}<br><br>`;
    ret = `${ret} Výše startovného je odvozena od data připsání částky na účet pořadatele (cca 2 pracovni dny). <br>`;
    ret = `${ret} O dokončení transakce Vás informujeme e-mailem, jakmile částka dojde na účet. <br>`;
    return  ret;
  }

  private createMessageDb(payInfo: PayInfo = null, subject, type){
    this.emailTableService.getOne(this.form.race.id).then((data) => {
      const toEmail = this.formArray.filter(i => i.key === 'email')[0].value;

      const email: EmailTable = type.toLowerCase() === 'hotově' ? data.data().emails.filter(i => i.messageType.toLowerCase() === EmailTable.ON_CASH.toLowerCase())[0] : data.data().emails.filter(i => i.messageType.toLowerCase() === EmailTable.ON_REG.toLowerCase())[0];

      let message = type.toLowerCase() === 'hotově' ? email.onCashMessage : email.onRegMessage;
      message = message.replace(EmailTable.key_name, this.payer.name);
      message = message.replace(EmailTable.key_surname, this.payer.surname);
      message = message.replace(EmailTable.key_year, this.registerFormService.regForm.year);
      message = message.replace(EmailTable.key_club, this.registerFormService.regForm.club);
      message = message.replace(EmailTable.key_startFee, payInfo.startFee+'');
      message = message.replace(EmailTable.key_varSym, payInfo.vs);
      message = message.replace(EmailTable.key_account, payInfo.account);
      message = message.replace(EmailTable.key_note, payInfo.note);
      message = message.replace(EmailTable.key_mobile, this.payer.mobile);
      message = message.replace(EmailTable.key_email, this.payer.email);
      message = message.replace(EmailTable.key_city, this.registerFormService.regForm.city);
      message = message.replace(EmailTable.key_custNote, this.registerFormService.regForm.note);

      const fromMail =  type.toLowerCase() === 'hotově' ? email.onCashFrom : email.onRegFrom;
      const subjectMail =  type.toLowerCase() === 'hotově' ? email.onCashSubject : email.onRegSubject;

      this.emailService.sendEmail(fromMail , toEmail, subjectMail, message).then(data => {

      });
    });
  }

  private createMessage( payInfo: PayInfo = null): string {
    let message = `Dobrý den, <br> byl jste přihlášený na závod:<br>`;
    message = `${message} ${this.form.race.name} <br>`;
    if (payInfo !== null) {
      message = `${message} ${this.generatePayInfo(payInfo)}<br>`;
    }
    message = `${message}Těšíme se na Vás na startu <br>${this.form.race.emailOr}<br>${this.form.race.web}`;

    return message;
  }

  saveRacer(type) {
    this.varSymService.getAllVarSym().then(data => {
      const vs = data.data().varSym;
      const payInfo: PayInfo = new PayInfo();
      payInfo.vs = vs;
      payInfo.note = `${this.payer.name} ${this.payer.surname}`;
      payInfo.name = `${this.payer.name} ${this.payer.surname}`;
      payInfo.account = this.form.payMethod.account;
      payInfo.startFee = this.getTotal();
      type = type.toLowerCase() === 'fio' ? 'převodem' : type;
      const now = new Date();
      const obj = {raceId: undefined, pay: type, paid: false, vs, timeOfReg: now, startFee: this.getTotal(), timeOfPay: -1, track: {}, rules: true};

      this.formArray.forEach(item => {
        obj[item.key] = item.value;
      });
      obj.track = this.registerFormService.regForm.track;
      obj.raceId = this.form.race.id;
      this.racerService.createRacer(obj).then( () => {
        this.payService.payInfo = payInfo;
        this.createMessageDb(payInfo, 'Přihlášení na závod', type);

        if (type === 'převodem') {
          this.router.navigate(['/accountInfo']);
        }
        else if (type.toLowerCase() === 'hotově') {
          this.router.navigate(['/cashInfo']);
        }
        this.varSymService.saveVarSym(vs);
      }).catch(err => {
        console.log('err');
        console.dir(err);
      });


    });



    // this.formArray; //hodnoty s udaji zavodnika
  }

  payCash() {
    // this.sendEmail('Přihlášení na závod', this.createMessage());
    this.removeOneVoucher();
    this.saveRacer('hotově');
  }

  payFio() {
    this.removeOneVoucher();
    this.saveRacer('fio');
  }

  removeOneVoucher(){
    if(this.registerFormService.regForm.voucher !== ''){
      this.voucherService.readOne(this.form.race.id).then(dVoucher => {
          const voucherList: Voucher[] = dVoucher.data().vouchers;
          if (this.noErr) {
            this.noErr = false;
            voucherList.forEach(v => {
              if (v.keyword === this.registerFormService.regForm.voucher) {
                v.pieces = v.pieces - 1;
              }
            });
            this.voucherService.update(voucherList, this.form.race.id);
          }
        }
      );
    }
  }

  goBack() {
    this.location.back();
  }

  payCard() {
    this.paying = true;

    this.goPayService.getGoPayByRaceId(this.form.race.id).then(data => {
      let i = 0;
      data.forEach(item => {

        if ( i === 0) {
          this.goPay = item.data() as GoPay;
          this.payService.goPayDetail = this.goPay;
          i++;
        }
      });

      this.payService.getToken(this.goPay).then( data => {
        const token: Token = data as Token;

        this.payService.standardPay(token, this.payer, this.getTotal(100),
          this.goPay.itemsName, this.goPay.returnUrl, this.goPay.itemsEan,
          this.goPay.itemsName, this.goPay.itemsProductUrl, this.goPay.currency, this.goPay.goId).then(dataPay => {
          // @ts-ignore
          window.location.href = dataPay.gw_url;
          // this.paying = false;
        });
      });

    });
  }

}
